module.exports = __webpack_public_path__ + "static/img/icon-authorised.fced6999.svg";